import { render, staticRenderFns } from "./bloggerApplication.vue?vue&type=template&id=7baea9c5&class=full-height&"
import script from "./bloggerApplication.vue?vue&type=script&lang=js&"
export * from "./bloggerApplication.vue?vue&type=script&lang=js&"
import style0 from "./bloggerApplication.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7baea9c5')) {
      api.createRecord('7baea9c5', component.options)
    } else {
      api.reload('7baea9c5', component.options)
    }
    module.hot.accept("./bloggerApplication.vue?vue&type=template&id=7baea9c5&class=full-height&", function () {
      api.rerender('7baea9c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/toursCombine/application/bloggerApplication.vue"
export default component.exports